import { ApolloError } from '@apollo/client';

/**
 * core-api refuses a cross-workflow filter whose hop resolves more ids than it will traverse,
 * rather than truncating the results. It carries its own error code (sc-83210) precisely so this
 * one recoverable case - the filters are valid, just too broad - can be told apart from the other
 * contract violations that share `SEARCH_QUERY_INVALID`.
 */
const RELATED_ENTITY_LIMIT_CODE = 'SEARCH_RELATED_ENTITY_LIMIT_EXCEEDED';

export function isRelatedEntityLimitError(error: unknown): boolean {
  if (!(error instanceof ApolloError)) {
    return false;
  }
  return error.graphQLErrors.some(graphQLError => {
    const coastApiError = graphQLError.extensions?.coastApiError as { code?: string } | undefined;
    return coastApiError?.code === RELATED_ENTITY_LIMIT_CODE;
  });
}
